/**
 * 서버 호출. 저장·제출 요청은 끊지 않는다. (v0.4.1) 결과 화면 조회(GET)만 signal로 취소할 수 있다. 응답을 받지 못하면 'network'로 돌려주고, 판단은 호출한 쪽이 한다.
 * 세대 번호(D-17): 요청을 보낼 때의 세대를 결과에 함께 싣는다. 세대가 바뀐 뒤 도착한 결과는 화면이 반영하지 않는다.
 */
export type ApiResult =
  | { readonly kind: 'http'; readonly status: number; readonly body: Record<string, any>; readonly gen: number }
  | { readonly kind: 'network'; readonly gen: number };

export interface RequestOptions {
  readonly body?: unknown; readonly key?: string;
  /** GET에만 쓴다(결과 화면 조회 묶음, DEV-I-008). 취소되면 'network'로 돌려준다. 저장·제출에는 넘기지 않는다 */
  readonly signal?: AbortSignal;
}

export interface Transport {
  request(method: 'GET' | 'POST' | 'PUT', path: string, opts?: RequestOptions): Promise<ApiResult>;
}

let generation = 0;
export const currentGen = (): number => generation;
/** 계정 전환·로그아웃·재로그인 시작·나가기 확정 때 올린다. */
export const bumpGen = (): number => ++generation;

export function fetchTransport(base = '/api'): Transport {
  return {
    async request(method, path, opts = {}) {
      const gen = generation;
      const headers: Record<string, string> = {};
      if (method !== 'GET') headers['content-type'] = 'application/json';
      if (opts.key !== undefined) headers['idempotency-key'] = opts.key;
      try {
        const res = await fetch(base + path, {
          method, headers, credentials: 'same-origin', cache: 'no-store',
          ...(method === 'GET' ? (opts.signal !== undefined ? { signal: opts.signal } : {}) : { body: JSON.stringify(opts.body ?? {}) }),
        });
        let body: Record<string, any> = {};
        try { body = (await res.json()) as Record<string, any>; } catch { body = {}; }
        return { kind: 'http', status: res.status, body, gen };
      } catch {
        return { kind: 'network', gen };
      }
    },
  };
}

/** 요청 키: 학생의 결정 하나(저장 내용 하나, 제출 의도 하나)에 하나. */
export function newRequestKey(): string {
  const bytes = new Uint8Array(12);
  globalThis.crypto.getRandomValues(bytes);
  return 'k' + Date.now().toString(36) + Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
}
